import { render, staticRenderFns } from "./UpdateScan.vue?vue&type=template&id=51eae5c0&scoped=true&"
import script from "./UpdateScan.vue?vue&type=script&lang=js&"
export * from "./UpdateScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eae5c0",
  null
  
)

export default component.exports